import { Card } from "@rumbledirect/ui";
import { Statistic } from "antd";

interface AntdCountChartProps {
  title: string;
  count: number | string;
  className?: string;
}

export const AntdCountChart = ({
  title,
  count,
  className,
}: AntdCountChartProps) => {
  return (
    <Card className={className} title={title}>
      <Statistic
        value={count}
        valueStyle={{
          fontSize: "4rem",
          fontWeight: "bold",
          textAlign: "center",
          minHeight: "250px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </Card>
  );
};
